import { Prompt } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import Errors from "./../../../shared/errors";
import {
  renderSingleReactSelect
} from "./../../../shared/form-helpers";
import required from "./../../../shared/validation";

function MakeupForm(props) {
  const {
    handleSubmit,
    handleDelete,
    pristine,
    reset,
    submitting,
    errors,
    mode,
    makeups
  } = props;

  const thisMakeup = props.initialValues || {};
  const readOnly = thisMakeup.readOnly;

  const makeupOptions = makeups?.map((e) => {
    return { label: e.name, value: e.id };
  });

  const noMakeups = !makeupOptions?.length;

  return (
    <>
      <Prompt when={!pristine} message="" />
      {mode === "add" && <h2 className="menu-label">Add makeup to scene</h2>}
      {mode === "edit" && (
        <h2 className="menu-label">Edit makeup in scene</h2>
      )}
      {errors && <Errors errors={errors} />}
      {noMakeups && <div>All makeups already added to scene</div>}

      {!noMakeups &&
        <form autoComplete="off" onSubmit={handleSubmit}>
          {mode === "add" && (
            <Field
              name="makeupId"
              label="Makeup"
              component={renderSingleReactSelect}
              value={thisMakeup.makeupId}
              validate={[required]}
              options={makeupOptions}
              required
              readOnly={readOnly}>
            </Field>
          )}
          {mode === "edit" && (
            <div className="field">
              <label className="label">
                Makeups
              </label>
              <div className="control">
                {thisMakeup.name}
              </div>
            </div>
          )}

          {!readOnly && <div className="buttons">
            <button
              type="submit"
              className="button is-primary"
              disabled={pristine || submitting}>
              Save
            </button>

            {mode === "edit" && (
              <button
                type="button"
                className="button is-text"
                disabled={submitting || !props.initialValues}
                onClick={() => handleDelete(thisMakeup)}>
                Remove from scene
              </button>
            )}
          </div>}
        </form>}
    </>
  );
}

export default reduxForm({
  form: "MakeupForm",
  enableReinitialize: true
})(MakeupForm);
